import { CalendarDate } from '@internationalized/date';
import {
  FreightChargeInput,
  ReceivedLineItemInput,
  ReconciliationDeductionInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const updateLoadReconciliationAtom = createMutationAtomFactory(
  'trade.reconciliationBatchUpdate',
  (params: {
    loadId: string;
    receivedLineItems?: ReceivedLineItemInput[];
    deductions?: ReconciliationDeductionInput[];
    freightCharges?: FreightChargeInput[];
    ticketNumber?: string;
    loadReceivedDate?: CalendarDate;
    ticketIssueDate?: CalendarDate;
    millReceivedWeightPostDate?: CalendarDate;
    externalNotes?: string;
    internalNotes?: string;
    invoiceType?: string;
  }) => {
    const input: Record<string, unknown> = {};

    // Only add fields if they have values
    if (params.receivedLineItems)
      input.receivedLineItems = params.receivedLineItems;
    if (params.deductions) input.deductions = params.deductions;
    if (params.freightCharges) input.freightCharges = params.freightCharges;
    if (params.ticketNumber) input.ticketNumber = params.ticketNumber;
    if (params.loadReceivedDate)
      input.loadReceivedDate = params.loadReceivedDate.toString();
    if (params.ticketIssueDate)
      input.ticketIssueDate = params.ticketIssueDate.toString();
    if (params.millReceivedWeightPostDate)
      input.millReceivedWeightPostDate =
        params.millReceivedWeightPostDate.toString();
    if (params.externalNotes) input.externalNotes = params.externalNotes;
    if (params.internalNotes) input.internalNotes = params.internalNotes;
    if (params.invoiceType) input.invoiceType = params.invoiceType;

    return {
      tradeReconciliationBatchUpdate: {
        __args: {
          loadId: params.loadId,
          ...input,
        },
        id: true,
        loadId: true,
        ticketNumber: true,
        loadReceivedDate: true,
        ticketIssueDate: true,
        millReceivedWeightPostDate: true,
        externalNotes: true,
        internalNotes: true,
        invoiceType: true,
        netShippedWeight: true,
        netReceivedWeight: true,
        netDelta: true,
        receivedLoadTotal: {
          amount: true,
          currencyCode: true,
        },
        files: {
          id: true,
          fileName: true,
          mimeType: true,
          status: true,
          metadata: true,
          fileSize: true,
          timestamps: {
            createdAt: true,
            updatedAt: true,
          },
        },
        receivedLineItems: {
          id: true,
          loadLineItemId: true,
          materialType: true,
          grossWeight: {
            value: true,
            unit: true,
          },
          tareWeight: {
            value: true,
            unit: true,
          },
          netWeight: {
            value: true,
            unit: true,
          },
          customerGrossWeight: {
            value: true,
            unit: true,
          },
          customerTareWeight: {
            value: true,
            unit: true,
          },
          unitPrice: {
            amount: true,
            currencyCode: true,
          },
          customerUnitPrice: {
            amount: true,
            currencyCode: true,
          },
          totalValue: {
            amount: true,
            currencyCode: true,
          },
          notes: true,
        },
        deductions: {
          id: true,
          receivedLineItemId: true,
          deductionTypeId: true,
          weightQuantity: {
            value: true,
            unit: true,
          },
          priceQuantity: {
            amount: true,
            currencyCode: true,
          },
        },
        freightCharges: {
          id: true,
          hauler: true,
          freightLane: true,
          deliveryNumber: true,
          accruedAmount: {
            amount: true,
            currencyCode: true,
          },
          chargebackAmount: {
            amount: true,
            currencyCode: true,
          },
          netAmount: {
            amount: true,
            currencyCode: true,
          },
          notes: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
